module.exports = __webpack_public_path__ + "img/lagoon-system.25ee46dd.jpg";